// LayoutEditorEmptyState.jsx

import React from 'react';

// CSS
import './LayoutEditorEmptyState.css';

/**
 * LayoutEditorEmptyState
 *
 * Renders the empty-state message shown before any layout rows have been added.
 *
 * @param {string} message - Empty-state copy to display.
 *
 * @returns {ReactNode} The rendered empty state.
 */
const LayoutEditorEmptyState = ({
	message = '',
}) => {

	// ----- RENDER ----- //

	return (
		<div
			className="layout-editor-empty-state-container"
		>
			{message}
		</div>
	);
};

// Dev Tools
LayoutEditorEmptyState.displayName = 'LayoutEditorEmptyState';

export default LayoutEditorEmptyState;
